import { render, staticRenderFns } from "./IqpDialogPrompt.vue?vue&type=template&id=4661c19f&scoped=true"
import script from "./IqpDialogPrompt.vue?vue&type=script&lang=js"
export * from "./IqpDialogPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661c19f",
  null
  
)

export default component.exports